module.exports = __webpack_public_path__ + "img/selected7-min.d41681b5.png";